import React, { FC } from 'react';
import ReactMarkdown from 'react-markdown';

interface MarkdownDisplayProps {
  markdownText: string;
}

const MarkdownDisplay: FC<MarkdownDisplayProps> = ({ markdownText }) => {
  return (
    <ReactMarkdown>{markdownText}</ReactMarkdown>
  );
}

export default MarkdownDisplay;

// 使用例
// const App: FC = () => {
//   const markdownContent = "# Hello, TypeScript!\n\nThis is **Markdown** with `types`.";
//   return <MarkdownDisplay markdownText={markdownContent} />;
// }